export const BaseRoutePath = '';
export const MiddleWelcomeRoutePath = 'welcome';

export const NotFoundRoutePath = 'not-found';
export const ForbiddenRoutePath = 'forbidden';
export const SoonAvailableRoutePath = 'soon-available';
export const LegalNoticesRoutePath = 'legal-notices';
export const TermsOfServiceRoutePath = 'terms-of-service';
export const HelpRoutePath = 'help';

export const AuthenticationRoutePath = 'authentication';
export const LoginRoutePath = 'login';
export const RegisterRoutePath = 'register';
export const LoginCallbackRoutePath = 'callback';
export const LoginFromSignupCallbackRoutePath = 'callback-from-signup';
export const LoginFromInviteCallbackRoutePath = 'callback-from-invite';
export const InviteFragment = 'from-invite';
export const LogoutRoutePath = 'logout';

export const NewAccountRoutePath = 'new-account';
export const NewAccountCompanyRoutePath = 'company';
export const NewAccountValidationRoutePath = 'validation';
export const NewAccountValidationRoutePathWithId = 'validation/:id';

export const SubsidiariesRoutePath = 'subsidiaries';
export const SubsidiaryDetailRoutePath = ':id';
export const SubsidiaryDetailCompanyRoutePath = 'company';
export const SubsidiaryDetailUsersRoutePath = 'users';

export const FederationsRoutePath = 'federations';
export const FederationCreateRoutePath = 'create';
export const FederationValidationRoutePath = 'validation';
export const FederationDetailRoutePath = ':id';
export const FederationDetailinfosRoutePath = 'federation';
export const FederationDetailUsersRoutePath = 'users';


export function getBasePath(): string {
	return BaseRoutePath;
}

// Generic pages
export function getNotFoundFullPath(): string {
	return `${getBasePath()}/${NotFoundRoutePath}`;
}

export function getForbiddenFullPath(): string {
	return `${getBasePath()}/${ForbiddenRoutePath}`;
}

// Authentication pages
export function getAuthenticationFullPath(): string {
	return `${getBasePath()}/${AuthenticationRoutePath}`;
}

export function getLoginFullPath(): string {
	return `${getAuthenticationFullPath()}/${LoginRoutePath}`;
}

export function getRegisterFullPath(): string {
	return `${getAuthenticationFullPath()}/${RegisterRoutePath}`;
}

export function getLoginCallbackFullPath(): string {
	return `${getAuthenticationFullPath()}/${LoginCallbackRoutePath}`;
}

export function getLoginFromSignupCallbackFullPath(): string {
	return `${getAuthenticationFullPath()}/${LoginFromSignupCallbackRoutePath}`;
}

export function getLoginFromInviteCallbackFullPath(): string {
	return `${getAuthenticationFullPath()}/${LoginFromInviteCallbackRoutePath}`;
}

export function getLogoutFullPath(): string {
	return `${getAuthenticationFullPath()}/${LogoutRoutePath}`;
}

// New account pages
export function getNewAccountFullPath(): string {
	return `${getBasePath()}/${NewAccountRoutePath}`;
}

export function getNewAccountCompanyFullPath(): string {
	return `${getNewAccountFullPath()}/${NewAccountCompanyRoutePath}`;
}

export function getNewAccountValidationFullPath(): string {
	return `${getNewAccountFullPath()}/${NewAccountValidationRoutePath}`;
}

export function getNewAccountValidationWithIdFullPath(id: number): string {
	return `${getNewAccountFullPath()}/${NewAccountValidationRoutePath}/${id}`;
}

// Subsidiaries pages
export function getSubsidiariesFullPath(): string {
	return `${getBasePath()}/${SubsidiariesRoutePath}`;
}

export function getSubsidiaryDetailFullPath(id: number): string {
	return `${getSubsidiariesFullPath()}/${SubsidiaryDetailRoutePath.replace(':id', '' + id)}`;
}

export function getSubsidiaryDetailCompanyFullPath(id: number): string {
	return `${getSubsidiaryDetailFullPath(id)}/${SubsidiaryDetailCompanyRoutePath}`;
}

export function getSubsidiaryDetailUsersFullPath(id: number): string {
	return `${getSubsidiaryDetailFullPath(id)}/${SubsidiaryDetailUsersRoutePath}`;
}

// Federations pages
export function getFederationsFullPath(): string {
	return `${getBasePath()}/${FederationsRoutePath}`;
}

export function getFederationCreateFullPath(): string {
	return `${getFederationsFullPath()}/${FederationCreateRoutePath}`;
}

export function getFederationValidationFullPath(): string {
	return `${getFederationsFullPath()}/${FederationCreateRoutePath}/${FederationValidationRoutePath}`;
}

export function getFederationDetailFullPath(id: number): string {
	return `${getFederationsFullPath()}/${FederationDetailRoutePath.replace(':id', '' + id)}`;
}

export function getFederationDetailinfosFullPath(id: number): string {
	return `${getFederationDetailFullPath(id)}/${FederationDetailinfosRoutePath}`;
}

export function getFederationDetailUsersFullPath(id: number): string {
	return `${getFederationDetailFullPath(id)}/${FederationDetailUsersRoutePath}`;
}
